export type CrmEntityType =
  | 'customer'
  | 'company'
  | 'traveler'
  | 'lead'
  | 'supplier'
  | 'person';

export function resolveCrmEntityRoute(entityType: CrmEntityType, id: string): string {
  switch (entityType) {
    case 'customer':
      return `/crm/customers/${id}`;
    case 'company':
      return `/crm/companies/${id}`;
    case 'traveler':
      return `/crm/travelers/${id}`;
    case 'lead':
      return `/crm/leads/${id}`;
    case 'supplier':
      return `/crm/suppliers/${id}`;
    case 'person':
      return `/crm/person/${id}`;
    default:
      return '/crm';
  }
}

export type CrmSectionKey =
  | 'home'
  | 'customers'
  | 'companies'
  | 'travelers'
  | 'leads'
  | 'suppliers'
  | 'communications'
  | 'documents'
  | 'vip'
  | 'segments';

export function resolveCrmSectionRoute(section: CrmSectionKey): string {
  switch (section) {
    case 'home':
      return '/crm';
    case 'customers':
      return '/crm/customers';
    case 'companies':
      return '/crm/companies';
    case 'travelers':
      return '/crm/travelers';
    case 'leads':
      return '/crm/leads';
    case 'suppliers':
      return '/crm/suppliers';
    case 'communications':
      return '/crm/communication-logs';
    case 'documents':
      return '/crm/documents';
    case 'vip':
      return '/crm/vip';
    case 'segments':
      return '/crm/segments';
    default:
      return '/crm';
  }
}
